
import FeatherIcon from 'feather-icons-react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// types
import { Feature } from './types';
import { Badge, Col, Container, Row } from 'react-bootstrap';
import SalesDashBoard from 'assets/images/hero/New folder/SalesDashBoard.png';
import QuoteAndSalesChart from 'assets/images/hero/New folder/QuoteAndSalesChart.png';
import LeadsOpportunitiAccounts from 'assets/images/hero/New folder/LeadsOpportunitiAccounts.png';
import leadsDetailsView from 'assets/images/hero/New folder/leadsDetailsView.png';

import SupportTicketHistory from 'assets/images/hero/New folder/SupportTicketHistory.png';
import campaginDetailsView from 'assets/images/hero/New folder/campaginDetailsView.png';
import AccountsDetailsView from 'assets/images/hero/New folder/AccountsDetailsView.png';
import opportunityDetails from 'assets/images/hero/New folder/opportunityDetails.png';
import "./Benefits.css";
import { useState } from 'react';
import { colors } from 'styles/colors';


type FeaturesProps = {
    features: Feature[];
};

const Features = ({ features }: FeaturesProps) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const slides = [SalesDashBoard, QuoteAndSalesChart, LeadsOpportunitiAccounts, leadsDetailsView, opportunityDetails, campaginDetailsView, AccountsDetailsView];
    const [activeText, setActiveText] = useState(0);

    const slidesData = [
        {
            image: SalesDashBoard,
            text: [
                "Monitor how sales orders are distributed across different execution stages. Get clear visibility into delivery and processing performance.",
                "Understand your overall sales performance with key business metrics. Track revenue trends and order efficiency in one unified dashboard."
            ]
        },
        {
            image: QuoteAndSalesChart,
            text: [
                "Monitor the overall quote performance and track how efficiently they convert into orders. This chart highlights your conversion effectiveness and sales closing strength.",
                "Analyze lead progression across contacted, nurturing, qualified, and active stages. Gain insights into overall sales performance and deal outcomes."
            ]
        },
        {
            image: LeadsOpportunitiAccounts,
            text: [
                "Stay informed about lead movement and engagement status in real time.",
                "Visualize deal progress from active discussions to closed outcomes.",
                "Understand account distribution by type to identify key business segments."
            ]
        },
        {
            image: leadsDetailsView,
            text: [
                "Access complete lead information including contact, company, and activity details.",
                "Track status updates and interactions in one centralized view."
            ]
        },

        {
            image: campaginDetailsView,
            text: [
                "This screen provides a detailed view of the selected campaign, including campaign information, schedule, and current status.",
                "It also displays distribution details and campaign form responses for each assigned user in a structured format."
            ]
        }
    ];

    const SlideCard = ({ index }: { index: number }) => (
        <Row className="align-items-center g-4 mb-4">
            <Col md={12}>
                <div className="slide-card p-4 rounded shadow-sm h-100">
                    {slidesData[index]?.text.map((paragraph, i) => (
                        <p key={i} className="slide-card-paragraph mb-2">
                            {/* {paragraph} */}
                            <span className="bullet-dot">•</span> {paragraph}
                        </p>
                    ))}

                </div>
            </Col>

        </Row>
    );



    return (
        <>
            <Container>
                {/* <section id="ai" className="grid gap-5 lg:grid-cols-2 items-center">
                    <div>
                        <p  className="inline-flex items-center gap-2 rounded-full bg-brand-teal/10 px-4 py-2 text-xs font-semibold text-brand-teal">
                            AI FEATURES
                        </p>
                        <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-slate-900">
                            Automate follow-ups and communication
                        </h2>
                        <p className="mt-3 text-slate-600">
                            Use AI to draft campaign emails, suggest next steps, and speed up support ticket assignment—so your team focuses on closing and helping customers.
                        </p>
                        <ul className="mt-4 space-y-3 text-slate-700">
                            <li className="flex gap-3">
                                <span className="text-brand-teal">✓</span>
                                AI email draft for campaigns
                            </li>
                            <li className="flex gap-3">
                                <span className="text-brand-teal">✓</span>
                                Smart follow-up reminders via tasks
                            </li>
                            <li className="flex gap-3">
                                <span className="text-brand-teal">✓</span>
                                Support ticket allocation by AI/email
                            </li>
                        </ul>
                    </div>

                    <div className="rounded-3xl border border-brand-border bg-brand-light p-4 shadow-soft">
                        <div className="rounded-2xl bg-white border border-brand-border p-3">
                            <p className="text-sm font-semibold text-slate-900">AI Draft Preview</p>
                            <p className="mt-2 text-sm text-slate-600">
                                Subject: Quick follow-up on your request<br />
                                Hi  ... , thanks for reaching out. Based on your needs, here are the next best steps...
                            </p>
                            <div className="mt-4 flex gap-3">
                                <span className="rounded-full bg-brand-teal/10 px-3 py-1 text-xs font-semibold text-brand-teal">
                                    Personalized
                                </span>
                                <span className="rounded-full bg-brand-indigo/10 px-3 py-1 text-xs font-semibold text-brand-indigo">
                                    On-brand
                                </span>
                                <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-700">
                                    Fast
                                </span>
                            </div>
                        </div>
                    </div>
                </section> */}
                <Container>
                    <section id="ai" className="grid gap-8 lg:grid-cols-2 items-center py-12">
                        {/* Left Content */}
                        <div>
                            <div className="bg-[#2dd4bf]/40 inline-flex items-center gap-2 rounded-full px-4 py-2">
                                <span className="text-xs font-semibold tracking-wide">AI  FEATURES</span>
                            </div>

                            <h2 style={{ color: colors.primary.darkBlue }} className="mt-4 text-3xl font-extrabold tracking-tight">
                                Automate follow-ups and communication
                            </h2>

                            <p className="mt-3 text-slate-600">
                                Use AI to draft campaign emails, suggest next steps, and speed up support ticket assignment—so your team focuses on closing and helping customers.
                            </p>

                            <ul className="mt-4 space-y-3 text-slate-700">
                                <li className="flex gap-3">
                                    <span style={{ color: colors.primary.teal }} className="text-brand-teal font-bold">✓</span>
                                    <span>AI email draft for campaigns</span>
                                </li>
                                <li className="flex gap-3">
                                    <span style={{ color: colors.primary.teal }} className="text-brand-teal font-bold">✓</span>
                                    <span>Smart follow-up reminders via tasks</span>
                                </li>
                                <li className="flex gap-3">
                                    <span style={{ color: colors.primary.teal }} className="text-brand-teal font-bold">✓</span>
                                    <span>Support ticket allocation by AI/email</span>
                                </li>
                            </ul>
                        </div>

                        {/* Right Content - Card */}
                        <div className="rounded-3xl border-2  border-brand-border bg-[#f8fafc] p-4 shadow-soft">


                            <div className="rounded-2xl bg-white border border-brand-border p-4">
                                <p className="text-sm font-semibold text-slate-900">AI Draft Preview</p>
                                <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                                    <span className="font-medium">Subject:</span> Quick follow-up on your request<br />
                                    <span className="font-medium">Hi</span> <span className="bg-amber-100 px-1">{'{Name}'}</span>, thanks for reaching out. Based on your needs, here are the next best steps...
                                </p>

                                {/* Tags with specific highlighting */}
                                <div className="mt-4 flex flex-wrap gap-2">
                                    {/* Personalized - Yellow highlight */}
                                    <span className="rounded-full bg-[#2dd4bf]/30 px-4 py-1.5 text-xs font-semibold border border-amber-200">
                                        Personalized
                                    </span>

                                    {/* On-brand - Blue highlight */}
                                    <span className="rounded-full bg-blue-100 px-4 py-1.5 text-xs font-semibold text-blue-700 border border-blue-200">
                                        On-brand
                                    </span>

                                    {/* Fast - Gray tag (not highlighted) */}
                                    <span className="rounded-full bg-slate-100 px-4 py-1.5 text-xs font-semibold text-slate-600">
                                        Fast
                                    </span>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Additional styles to match screenshot exactly */}

                </Container>
            </Container>

            <section className="py-5 mt-5   position-relative">
                <Container>
                    <Row className="mb-5">
                        <Col className="text-center">
                            <Badge bg="primary" pill className="mb-3 px-3 py-2">
                                Features
                            </Badge>

                            <h4 style={{ color: colors.primary.darkBlue }} className="mt-3">
                                Powerful modules that help your business grow, manage customers, and close more deals.
                            </h4>
                        </Col>
                    </Row>

                    {/* <Row className="g-4">
                        {features.map((benefit, index) => (
                            <Col lg={6} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                                <div className="d-flex p-4 border border-2 rounded bg-white rounded shadow-sm h-100 align-items-start">
                                    <div className="me-4">
                                        <div className="d-flex align-items-center justify-content-center bg-primary bg-opacity-10 text-primary rounded-circle" style={{ width: 48, height: 48 }}>
                                            <FeatherIcon icon={benefit.icon} size={20} />
                                        </div>
                                    </div>
                                    <div>
                                        <h5 className="fw-semibold">{benefit.title}</h5>
                                        <p className="text-muted mb-0">{benefit.description}</p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row> */}

                    <Row className="g-4">
                        {features.map((benefit, index) => (
                            <Col lg={6} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                                <div
                                    style={{ animation: `fadeInUp 0.6s ease-out ${index * 0.1}s both` }}

                                    className="benefit-card border-2 position-relative p-4 rounded bg-white shadow-sm h-100 d-flex align-items-start">

                                    <div className={`hover-bg position-absolute top-0 start-0 w-100 h-100`} />

                                    <div className="hover-corner position-absolute top-0 end-0"></div>

                                    <div className="me-4 position-relative z-1">
                                        <div
                                            className="d-flex align-items-center justify-content-center rounded-circle icon-box"
                                            style={{ width: 48, height: 48, background: colors.primary.teal, color: colors.neutral.white }}
                                        >
                                            <FeatherIcon icon={benefit.icon} size={20} />
                                        </div>
                                    </div>

                                    <div className="position-relative z-1">
                                        <h5 style={{ color: colors.primary.darkBlue }} className="fw-semibold mb-2 benefit-title">{benefit.title}</h5>
                                        <p className="text-muted mb-0">{benefit.description}</p>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>


            <section className="position-relative py-5">
                <Container>
                    <Row className="justify-content-center text-center mb-5">
                        <Col lg={8}>
                            <h2 className="fw-bold">
                                Performance tracking <span className="text-primary">made easy</span>
                            </h2>
                            <p className="text-muted lead mt-3">
                                Keep track of your pipelines, targets, and team performance
                            </p>
                        </Col>
                    </Row>

                    <SlideCard index={activeIndex} />
                    <div className="swiper-wrapper-custom px-7">

                        <Swiper
                            modules={[Pagination, Navigation]}
                            slidesPerView={1}
                            loop={true}
                            speed={1200}
                            pagination={{
                                clickable: true
                            }}
                            spaceBetween={0}
                            navigation={{
                                prevEl: ".swiper-button-prev-custom",
                                nextEl: ".swiper-button-next-custom",
                            }}
                            onBeforeInit={(swiper) => {
                                // @ts-ignore
                                swiper.params.navigation.prevEl = ".swiper-button-prev-custom";
                                // @ts-ignore
                                swiper.params.navigation.nextEl = ".swiper-button-next-custom";
                                // @ts-ignore
                            }}
                            onSlideChange={(swiper) => {
                                setActiveIndex(swiper.realIndex);
                            }}
                        >
                            {slidesData.map((slide, idx) => (
                                <SwiperSlide key={idx}>
                                    <img src={slide.image} alt={`slide-${idx}`} className="simple-img" />
                                </SwiperSlide>
                            ))}
                        </Swiper>

                        <div className="swiper-button-prev-custom nav-btn left mx-2">‹</div>
                        <div className="swiper-button-next-custom nav-btn right mx-2">›</div>
                    </div>

                    {/* <SlideCard index={activeIndex} /> */}
                </Container>
            </section>
        </>
    );
};

export default Features;
